import useAuthUser from "@/hooks/useAuthUser";
import emitter from "@/lib/emitter";
import { LoginSignUpModalData } from "@/types";
import { EVENTS } from "@/const";

export default function useAuthorisedOnly<T extends (...args: any) => any>(
  cb: T,
  loginSignUpModalData?: LoginSignUpModalData
): (...args: Parameters<T>) => ReturnType<T> {
  const { authUser } = useAuthUser();
  return (...args) => {
    if (!authUser.value) {
      emitter.emit(EVENTS.SHOW_LOGIN_SIGNUP_MODAL, loginSignUpModalData);
      return;
    }
    // eslint-disable-next-line prefer-spread
    return cb.apply(undefined, args);
  };
}
